var map = {
	"./aa-National Award for TBI @ KEC.pdf": 11146,
	"./ab-EEE Department of Kongu Engineering College awarded as the Best Industry linked Technical Institute by AICTE CII Survey.pdf": 75085,
	"./ac-National Award for the Best Engineering College Principal by ISTE.pdf": 14805,
	"./ad-Award for Outstanding Institute Industry Partnership 2014.pdf": 6943,
	"./ae-Life Time Achievement award for Prof. S.Kuppuswami (Former Principal) by Nehru Group of Institutions.pdf": 44676,
	"./af-International Achievers Award for Excellence in Education for Prof. S.Kuppuswami (Former Principal).pdf": 59211,
	"./ag-Best E-Cell Entrepreneurship Eco System Builder Award 2015.pdf": 23511,
	"./ah-Award for Outstanding Institute Industry Partnership 2015 (Second Time).pdf": 53530,
	"./ai-Best Academic Administrator Award for Prof. S.Kuppuswami (Former Principal).pdf": 99756,
	"./aj-Award for Outstanding Institute Industry Partnership 2016 (Third Time).pdf": 36806,
	"./ak-Outstanding Engineer Award 2016 for Prof. S.Kuppuswami (Former Principal).pdf": 38374,
	"./al-AICTE Clean Campus Award 2017.pdf": 26582,
	"./am-Best Performing Institution Innovation Council from the South Zone.pdf": 71465,
	"./an-AICTE certificate of appriciation for contribution in Jal Shakti Abhiyan.pdf": 9633,
	"./ao-AICTE certificate of appriciation for contribution in One Student One Tree.pdf": 35854,
	"./ap-AICTE National Level Clean & Smart Campus Awards - 2019.pdf": 93823,
	"./aq-AICTE Swachh Campus Ranking 2019 award for Cleanest Higher Educational Institutions in the Country.pdf": 16471,
	"./ar-Kongu Engineering College Bagged Tamil Nadu Government Green Champion Award 2021.pdf": 23339,
	"./as-Kongu Engineering College Received the Most Prestigious Deputy Director General Shield.pdf": 46645,
	"./at-Kongu Engineering College, Perundurai Received Certificate of Appreciation from Deputy Director General of NCC for NCC Activities.pdf": 99312,
	"./au-Kongu Engineering College, Perundurai Received National Level Recognition Certificate from MathWorks.pdf": 51072,
	"./av-Kongu Engineering College, Perundurai Received IETE Organisational National Award.pdf": 95934,
	"./aw-Kongu Engineering College, Perundurai received GOLD Certificate of appreciation - Energy Literacy Training - an AICTE Initiative.pdf": 25211,
	"./ax-Kongu Engineering College Received Awards from Institution of Engineers (India).pdf": 70417,
	"./ay-Students of Kongu Engineering College Won First Prize in AICTE National Level Contest.pdf": 6814,
	"./az-Kongu Engineering College has been awarded the Outstanding Host Award by SAEINDIA Southern Section.pdf": 93101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46595;